import { createFileRoute } from '@tanstack/react-router'
import { programSearchSchema } from '@/features/programs/filter-programs/model/programSearch'
import { ProgramsPage } from '@/pages/programs/ui/ProgramsPage'

export const Route = createFileRoute('/programs')({
  validateSearch: programSearchSchema,
  component: ProgramsPage,
})
